'use strict'

const Tabs = {
    btns: [], 
    slides: [],
    el: null,
    header: null,
    placeholder: null,
    offset: 0,
    tabsOffsetTop: 0,
    ticking: false,

    init: function() {
        Tabs.btns = document.querySelectorAll('.tab-btn');
        Tabs.slides = document.querySelectorAll('.tab-slide');

        if (Tabs.btns.length && Tabs.slides.length) {
            Tabs.btns.forEach((tab, index) => {
                tab.addEventListener('click', () => Tabs.activate(tab));
                tab.addEventListener('keydown', (e) => Tabs.onKeydown(e, index));
            });
        }

        //Gestion du sticky
        Tabs.el = document.querySelector('.c-tabs');
        Tabs.header = document.querySelector('.header');
        Tabs.placeholder = document.querySelector('.placeholderTabs');

        if (!Tabs.el || !Tabs.header || !Tabs.placeholder) return;

        Tabs.tabsOffsetTop = Tabs.placeholder.offsetTop;

        window.addEventListener('scroll', Tabs.onScroll);
        window.addEventListener('resize', Tabs.onResize);
        window.addEventListener('load', Tabs.update);
    },

    // Select a tab: update aria-selected, roving tabindex and show its panel.
    activate: function (tab) {
        Tabs.btns.forEach(btn => {
            btn.classList.remove('active');
            btn.setAttribute('aria-selected', 'false');
            btn.setAttribute('tabindex', '-1');
        });

        Tabs.slides.forEach(slide => slide.classList.remove('active'));

        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');

        const id = tab.dataset.value;
        const currentSlide = document.querySelector(`.tab-slide[data-id="${id}"]`);
        currentSlide.classList.add('active');

        // Refresh the tab's Swipers: sized wrong while in display:none.
        currentSlide.querySelectorAll('.swiper').forEach(swiperEl => {
            if (swiperEl.swiper) {
                swiperEl.swiper.update();
            }
        });

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    },

    // Roving tabindex: move focus between tab titles (manual activation).
    // Panel changes only on Enter/Space/click.
    focusTab: function (index) {
        const count = Tabs.btns.length;
        const target = (index + count) % count;

        Tabs.btns.forEach((btn, n) => btn.setAttribute('tabindex', n === target ? '0' : '-1'));
        Tabs.btns[target].focus();
    },

    onKeydown: function (e, index) {
        switch (e.key) {
            case 'ArrowRight':
                e.preventDefault();
                Tabs.focusTab(index + 1);
                break;
            case 'ArrowLeft':
                e.preventDefault();
                Tabs.focusTab(index - 1);
                break;
            case 'Home':
                e.preventDefault();
                Tabs.focusTab(0);
                break;
            case 'End':
                e.preventDefault();
                Tabs.focusTab(Tabs.btns.length - 1);
                break;
        }
    },

    onScroll: function () {
        if (Tabs.ticking) return;

        Tabs.ticking = true;
        requestAnimationFrame(() => {
            Tabs.update();
            Tabs.ticking = false;
        });
    },

    onResize: function () {
        Tabs.tabsOffsetTop = Tabs.placeholder.offsetTop;
        Tabs.update();
    },

    update: function () {
        const scrollY = window.scrollY;

        // Live header bottom edge in the viewport: the header shrinks on scroll
        // (hidden-- class) and is pushed down by the WP admin bar when logged in.
        // getBoundingClientRect().bottom captures its real bottom in every case,
        // so the sticky tabs sit flush against it instead of leaving a gap.
        Tabs.offset = Tabs.header.getBoundingClientRect().bottom;

        if (scrollY + Tabs.offset >= Tabs.tabsOffsetTop) {
            Tabs.el.classList.add('sticky');
            Tabs.el.style.top = `${Tabs.offset}px`;
            Tabs.placeholder.style.height = `${Tabs.el.offsetHeight}px`;
        } else {
            Tabs.el.classList.remove('sticky');
            Tabs.el.style.top = '';
            Tabs.placeholder.style.height = '';
        }
    }
};

export default Tabs;
